import React from 'react';
import "./ServicesSettings.scss"

import ModalComponent from '../../UI/ModalComponent/ModalComponent';
import ServicesSettingsList from '../ServicesSettingsList/ServicesSettingsList';

const ServicesSettings = () => {

	return (
		<div className="services-settings">
			<ModalComponent
					sidebar={true}
					button={<div className="services-settings__button"></div>}>
					<ServicesSettingsList/>
			</ModalComponent>
		</div>
	);
};

export default ServicesSettings;
